import React from "react";

export function RssFeed() {
	return (
		<section className="search-results-rss">
			<a
				href="/news/feed"
				className="btn btn--secondary btn--has-icon btn--rss"
			>
				<span>Get our RSS Feed</span>
			</a>
		</section>
	);
}
